import { useCallback } from 'react';
import { useAppSelector } from '../../../../store/hooks';
import { selectGetCompanyPartnerRelations } from '../../../../store/slices/dashboardSlice';

export function useGetCompanyPartnerRelation() {
  const companyPartnerRelations = useAppSelector(selectGetCompanyPartnerRelations);
  return useCallback((partnerId: string) => companyPartnerRelations?.find(
    (cp) => (
      cp?.partnerId && cp.partnerId === partnerId
    ),
  ), [companyPartnerRelations]);
}
